<template>
  <div>
    <div
      class="modal fade"
      id="newacounttypeModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newacounttypeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="pull-left">
              <h4 class="modal-title">Add account type</h4>
            </div>
          </div>
          <div class="modal-body">
            <form @submit.prevent="newAccount()">
              <div class="form-group">
                <label>Account name</label>
                <input
                  type="text"
                  class="form-control account_name"
                  placeholder="accounttype name"
                  required
                />
              </div>
              <button
                type="submit"
                class="btn btn-primary btn-flat creatingAccounttype btn-rounded"
              >
                <i class="fa fa-plus"></i> create Account type
              </button>
              <button
                type="button"
                class="
                  btn btn-primary btn-flat
                  creatingAccounttypeLoader
                  btn-rounded
                "
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                please wait...
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >manage account types</small
        >
        <div class="pull-right">
          <button
            type="button"
            data-toggle="modal"
            data-target="#newacounttypeModal"
            class="btn btn-primary btn-sm"
          >
            <i class="fa fa-plus"></i> Add leave type
          </button>
        </div>
      </legend>
      <div></div>
      <div class="accounttypesLoader">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <i
          class="fa fa-spinner fa-spin"
          style="font-size: 24px; color: blue"
        ></i
        >loading accounttypes...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemAccounttypes"
        :fixed-header="true"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 6,
          position: 'bottom',
          perPageDropdown: [3, 7, 9],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
      ></vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Account code",
          field: "account_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by accounttype code",
          },
        },
        {
          label: "Account name",
          field: "account_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by account name",
          },
        },
        {
          label: "Submmitted by",
          field: "fullname",
          type: "text",
        },
      ],
    };
  },
  created() {
    this.loadAccounttypes();
  },
  computed: {
    ...mapGetters(["systemAccounttypes"]),
  },
  methods: {
    ...mapActions(["loadAccounttypes", "newAccount"]),
  },
};
</script>
<style scoped>
.creatingAccounttypeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/accounttypes/manageaccounttypes.vue